import { isRequired } from '@monorepo/shared/utils/validators';
import React, { useCallback } from 'react';
import { useField } from 'react-final-form';
import styled from 'styled-components';
import { EditableFormTemplateField } from '../../types';
import { DeleteConditionalPropertyButton } from '../DeleteConditionalPropertyButton';
import { ConditionalFieldValueFactory } from './ConditionalFieldValueInputs/ConditionalFieldValueFactory';

const StyledRow = styled.div`
  display: flex;
  flex-direction: row;
  align-items: end;
`;

interface ConditionalFieldValueInputRowProps {
  name: string;
  index: number;
  hasOverallError: boolean;
  triggerField: EditableFormTemplateField;
  onDelete: (index: number) => void;
  isDeletable: boolean;
  rulePrefix: string;
}

export function ConditionalFieldValueInputRow({
  name,
  index,
  hasOverallError,
  triggerField,
  onDelete,
  isDeletable,
  rulePrefix,
}: ConditionalFieldValueInputRowProps) {
  const { meta } = useField(name, { validate: isRequired });

  const hasError = !!meta.error && (meta.touched || meta.modified);

  const handleRemove = useCallback(() => {
    onDelete(index);
  }, [onDelete, index]);

  return (
    <StyledRow>
      <ConditionalFieldValueFactory
        triggerField={triggerField}
        rulePrefix={rulePrefix}
        inputFieldProps={{
          name,
          label: index === 0 ? 'Conditions' : 'or',
          placeholder: 'enter conditions',
          error: hasError || hasOverallError,
          errorText: hasError ? meta.error : undefined,
        }}
      />
      <DeleteConditionalPropertyButton
        remove={handleRemove}
        label="Delete conditional field value"
        $isVisible={isDeletable}
        $isErrorTextShown={!!hasError}
      />
    </StyledRow>
  );
}
